/**
 * 계약 유형 제목(= 모두싸인 템플릿 제목 = v1 create 라우트 name) → v5 create 라우트 name 매핑.
 *
 * 왜 있는가:
 * - ContractItemV5 는 클릭 시 `$router.push({name: title})` 로 이동한다. title 은 유형 선택
 *   화면이 모두싸인 템플릿 목록에서 뽑아온 제목이며, 동시에 router.enums.js 에 등록된 v1
 *   create 라우트의 name 과 같다.
 * - v5 는 router.enums.js(v1 소유 파일)를 건드리지 않으므로 v5 라우트 name 을 여기서 정의한다.
 *
 * [HARD] v5 트리에 실체가 있는 화면은 **물품매매 V5·V6 둘뿐**이고, 카드는 V6 로 보낸다.
 *   v5 는 개정 서식(물품매매V5·V6)을 위해 만든 창구다. 이 표의 값은 「카드가 갈 곳」이다 —
 *   V5 화면의 라우트 name 은 이 표에서 계산하지 않고 화면 쪽 고정 상수(MULPUM_V5_ROUTE_NAME)로
 *   뗐다. 그래서 여기 값을 V6 로 바꿔도 V5 라우트는 이름이 겹쳐 지워지지 않고 직접 주소로 남는다.
 *   나머지 5종은 서식이 바뀌지 않았으므로
 *   복사본을 두지 않고 **v3 라우트로 보낸다**. 복사본을 만들면 같은 화면이 두 벌이 되어
 *   한쪽만 고치는 사고가 난다 — 실제로 v2·v3 사이에서 그 방식으로 유지비가 늘었다.
 *
 *   v1 로 폴백하지 않는 이유: v1 create 창구는 제거가 확정돼 폴백 대상이 사라진다.
 *   맵에 없는 제목이 들어오면 존재하지 않는 라우트로 이동해 **카드 클릭이 조용히 무반응**이 되므로,
 *   6종 전부를 여기서 명시한다.
 */
export const CONTRACT_TITLE_TO_V5_CREATE_ROUTE_NAME = {
  // 물품매매 — 2차 개정 서식(계약유형 물품매매V6, 프릭스 slug dentium-mulpum-v6·-mgr-branch).
  // V5 화면(MULPUM_V5_ROUTE_NAME)은 직접 주소로만 남는다(임시저장 복원·비상용). 되돌림 = 이 값을 V5 로.
  '덴티움 물품 매매 계약서': '덴티움 물품 매매 계약서V6',

  // 아래 5종은 서식 무변경 → v3 화면 그대로 사용한다. 이름 끝의 V3 는 오타가 아니다.
  'BNK역구매': 'BNK역구매V3',
  '신협역구매': '신협역구매V3',
  'Chair 제품설치 확인서 수정 (Rev.3)': 'Chair 제품설치 확인서 수정 (Rev.3)V3',
  'Dentium-CBCT-설치완료 확인서 (Rev.5)': 'Dentium-CBCT-설치완료 확인서 (Rev.5)V3',
  'ACTILINK 정기 렌탈서비스 약정서': 'ACTILINK 정기 렌탈서비스 약정서V3',
};

/**
 * 계약서 제목으로 create 라우트 name 을 찾는다.
 * 맵에 없으면 title 을 그대로 돌려준다(= v1 라우트 name 폴백).
 */
export function resolveContractCreateRouteName(title) {
  return CONTRACT_TITLE_TO_V5_CREATE_ROUTE_NAME[title] || title;
}
